<div class="w-100 h-100 d-flex flex-column align-items-start wrapper animated fadeIn">
	<button type="button" data-test-id="btn-back" class="btn btn-back" (click)="openTotalSavingPanel.emit()">Back</button>
	<div class="header d-flex align-items-baseline" data-test-id="header">
		<h2 class="title mb-0" data-test-id="title">Linux Uncovered On-Demand</h2>
		<p class="subtitle mb-0" data-test-id="subtitle">This graph illustrates VM on-demand cost by day</p>
	</div>
	<div class="chart-wrapper" data-test-id="chart-wrapper">
		<ng-container *ngIf="chartUpdatedOption; else loading">
			<div class="chart" echarts [options]="chartUpdatedOption" [merge]="chartUpdatedOption" data-test-id="chart"></div>
		</ng-container>
	</div>
	<div class="d-flex total-cost" *ngIf="data" data-test-id="total-cost">
		<span class="total-cost__text total-cost__text--highlighted" data-test-id="total-cost-highlighted"
			>Total cost: {{ data.expiredCommitmentsUncoveredDaily + data?.steadyState | emptyValue }}</span
		>
		<span class="total-cost__text" data-test-id="total-cost-expired"
			>Expired commitments uncovered daily: ${{ data?.expiredCommitmentsUncoveredDaily | emptyValue }}</span
		>
		<span class="total-cost__text" data-test-id="total-cost-steady"
			>Steady state: ${{ data?.steadyState | emptyValue }}</span
		>
	</div>
</div>

<ng-template #loading>
	<app-spinner data-test-id="loading-spinner"></app-spinner>
</ng-template>
